import request from "../utils/request";

function get(params) {
    params.is_delete = false
    return request({
        url: `/notification-request/get`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}

function accepted(data) {
    return request({
        url: `/notification-request/accepted`,
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        data: data
    })
}

function cancel(data) {
    return request({
        url: `/notification-request/cancel`,
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        data: data
    })
}

function del(params) {
    return request({
        url: `/notification-request/delete`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
} 

function getDataChart(params) {
    return request({
        url: `/request-log/get`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
} 

function getDataChartByPlatform(params) {
    return request({
        url: `/request-log/by-platform`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
} 

function report(params) {
    return request({
        url: `/notification-request/report`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}

function notiExport(params) {
    return request({
        url: `/notification-request/export`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}


function requestByStatus(params) {
    return request({
        url: `/request-log/by-status`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}

const NotificationRequestService = {
    get,
    accepted,
    cancel,
    del,
    getDataChart,
    report,
    requestByStatus,
    notiExport,
    getDataChartByPlatform
};

export default NotificationRequestService;